<template>
    <div
        v-show="jobs"
        class="block--job-board container--lg mx-auto gutter--xs"
    >

        <div
            v-for="(jobs, department) in opportunities"
            :key="department"
            class="assets-list"
        >
            <div class="assets-list__header">
                <h3 class="list-header">{{ department }}</h3>
            </div>

            <div class="assets-list__list">
                <a
                    v-for="job in jobs"
                    :key="job.id"
                    :href="`/job?gh_jid=${job.id}&did=${job.departments[0].id}`"
                    class="assets-list__item"
                >
                    <div class="assets-list__item-content">
                        <h4 class="header">{{ job.title }}</h4>
                        <div class="descr">
                            <p>{{ job.location.name }}</p>
                        </div>
                    </div>
                    <div class="assets-list__item-action">
                        <button class="btn -sm -gradient"><span class="btn__text">See Details</span></button>
                    </div>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios"

export default {

    data() {
        return {
            jobs: [],
        }
    },

    computed: {
        opportunities() {
            let opportunities = {}
            for (let job of this.jobs) {
                let department = job.departments[0].name
                if (!(department in opportunities)) {
                    opportunities[department] = []
                }
                opportunities[department].push(job)
            }
            return opportunities
        }
    },

    created() {
        this.loadJobs()
    },

    methods: {
        loadJobs() {
            axios.get('https://boards-api.greenhouse.io/v1/boards/toyotaconnected/jobs?content=true')
            .then((response) => {
                this.jobs = response.data.jobs
            })
        },
    },

}
</script>
